import { render, staticRenderFns } from "./RollCall.vue?vue&type=template&id=12d4d4fc&scoped=true"
import script from "./RollCall.vue?vue&type=script&lang=js"
export * from "./RollCall.vue?vue&type=script&lang=js"
import style0 from "./RollCall.vue?vue&type=style&index=0&id=12d4d4fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4d4fc",
  null
  
)

export default component.exports